/**
 * 영속성/인증 모드 — 'local'(스탠드얼론, 백엔드 /api/local) 또는 'qbase'(QBase 테넌트).
 *
 * REACT_APP_PERSISTENCE 가 있으면 그 값이 우선. 없으면 REACT_APP_QBASE_SYS_ID 유무로 추론한다
 * (기존 개발자의 .env 를 조용히 로컬로 뒤집지 않기 위해서 — QBase 설정이 있으면 지금까지처럼 QBase 모드).
 * 스탠드얼론 도커 이미지는 빌드 시 REACT_APP_PERSISTENCE=local 을 명시하므로 추론에 기대지 않는다.
 */
export type Persistence = 'local' | 'qbase';

const explicit = (process.env.REACT_APP_PERSISTENCE || '').trim().toLowerCase();

export const PERSISTENCE: Persistence =
  explicit === 'qbase' ? 'qbase'
    : explicit === 'local' ? 'local'
      : (process.env.REACT_APP_QBASE_SYS_ID || '').trim() ? 'qbase' : 'local';

export const IS_LOCAL = PERSISTENCE === 'local';
